import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';

import { FromUndergroundTime } from './parts/FromUndergroundTime';
import * as styles from './Underground.css';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { IGeoUndergroundInfo } from '../../../node/repositories/newbuilding-card/entities/geo/GeoUndergroundInfo';
import { UndergroundIcon } from '../Underground/parts/UndergroundIcon';

interface IUndergroundsProps {
  underground: IGeoUndergroundInfo[];
  regionId: number | null;
}

export function Undergrounds({ underground, regionId }: IUndergroundsProps) {
  return (
    <>
      {underground.map(undergroundItem => (
        <div key={`${undergroundItem.name}`} className={styles['underground']}>
          {/*Station*/}
          <div className={styles['underground-station']}>
            {undergroundItem.lineColor && <UndergroundIcon lineColor={undergroundItem.lineColor} regionId={regionId} />}
            <InlineText2>{`м. ${undergroundItem.name}`}</InlineText2>
          </div>
          {/*Distance*/}
          <div className={styles['underground-distance']}>
            <FromUndergroundTime timeTransport={undergroundItem.timeTransport} timeWalk={undergroundItem.timeWalk} />
          </div>
        </div>
      ))}
    </>
  );
}
